import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import HotelPricingAssistantTableCellsTdOwnRateDynamicRatePricing from 'lumen/components/hotel/pricing-assistant/table/cells/td-own-rate-dynamic-rate-pricing';
import type { TablePricingManagerContextColumn } from 'lumen/components/hotel/pricing-assistant/table/table-pricing-manager';
import type { Carate, Period } from 'lumen/models';

interface HotelPricingAssistantTableCellsTdRoomRateMonthSignature {
  Args: {
    column: TablePricingManagerContextColumn;
    row: { period: Period };
    value: Carate | undefined;
  };
}

// The price cell needs a carate, which a room can lack on a given day.
export default class HotelPricingAssistantTableCellsTdRoomRateMonth extends Component<HotelPricingAssistantTableCellsTdRoomRateMonthSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get isPast(): boolean {
    return this.hotelAndMarketService.isPast(this.args.row.period.fromDate);
  }

  <template>
    {{#if @value}}
      <HotelPricingAssistantTableCellsTdOwnRateDynamicRatePricing
        @column={{@column}}
        @value={{@value}}
      />
    {{else}}
      <div
        class="mr-500 {{if this.isPast 'text-disabled' 'text-neutral-subdued'}}"
      >
        {{t "general.missing"}}
      </div>
    {{/if}}
  </template>
}
